<template>
  <div class="animated fadeIn">
    <div v-if="!assessment._id">
      <p>Lighthouse Indicator not found, or you do not have access to this person in the given Org/Group context.</p>
    </div>
    <div v-if="assessment._id">
      <b-row>
          <b-col sm="12">
            <assessment-form
              v-bind:assessment="assessment"
              :locations="organization.locations"
              :programs="organization.programs"
              v-on:addOrUpdate="addOrUpdate"
            ></assessment-form>
          </b-col>
      </b-row>
    </div>
    <b-modal
      title='Success'
      @ok="handleOk"
      header-bg-variant="success"
      header-text-variant="light"
      size="sm"
      :visible="showAssessmentUpdatedModal"
      centered
      id="modal1"
      ok-only
    >
    <template #modal-header-close>
      <h4>X</h4>
    </template>
      <h4>Lighthouse Indicator Record Updated Successfully</h4>
      <p>{{ assessment.id }}</p>
    </b-modal>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import assessmentForm from '@/views/t1/AssessmentForm'

export default {
  name: 'editassessment',
  components: {
    assessmentForm
  },
  computed: {
    ...mapGetters({
      assessment: 'getEditAssessment',
      organization: 'getViewOrganization',
      showAssessmentUpdatedModal: 'showAssessmentUpdatedModal',
      userCurrentContext: 'userCurrentContext'
    })
  },
  methods: {
    ...mapActions([
      'getAssessmentForEdit',
      'updateAssessment'
    ]),
    handleOk (evt) {
      this.$router.push('/screening/' + this.assessment.id)

      // Reset pieces of state
      this.$store.commit('setShowAssessmentUpdatedModal', false)
      this.$store.commit('resetEditAssessment')
    },
    addOrUpdate () {
      this.$validator.validate().then(result => {
        if (result) {
          if (this.assessment._id) {
            var user = this.$auth.user()
            this.assessment.updatedBy = user.id
            this.$store.dispatch('updateAssessment', this.assessment)
          }
        }
      })
    },
    fetchData () {
      var id = this.$route.params.id
      if (id) {
        this.$store.dispatch('getAssessmentForEdit', { id: id })
      }
      const organizationId = this.userCurrentContext.organization.id
      this.$store.dispatch('getOrganizationView', {
        id: organizationId
      })
    }
  },
  watch: {
    userCurrentContext: function (newValue) {
      if (newValue) {
        this.fetchData()
      }
    }
  },
  created () {
    this.fetchData()
  },
  data: function () {
    return {
      errors: []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/t1/EditAssessment.vue